module.exports = __webpack_public_path__ + "img/custmobg.55c45938.jpg";